<template>
    <div class="layout">
        <Layout>
            <Header>
                <Menu mode="horizontal" theme="dark" active-name="1" @on-select="langSwitch">
                    <div class="layout-logo"></div>
                    <div class="logout_box">
                        <Icon type="ios-contact" size="25" />
                        <div class="name">admin</div>
                        <span class="fh">|</span>
                    <span class="logout" @click="logout">{{$t("menu.loginOut")}}</span>
                    </div>
                     <Submenu name="lang" style="float:right">
                          <template slot="title">
                            <Icon type="md-list" />{{$t("menu.lang")}}
                        </template>
                        <MenuItem name="zh">{{$t("menu.zh")}}</MenuItem>
                        <MenuItem name="vn">{{$t("menu.vn")}}</MenuItem>
                     </Submenu>

                </Menu>
            </Header>
            <Layout>
                <Sider hide-trigger :style="{background: '#fff'}">
                    <Menu
                        :active-name="active_nav"
                        theme="light"
                        width="200"
                        @on-select="select_nav"
                    >
                        <MenuItem name="1-1" to="home">
                            <Icon type="md-home" />
                            <span>{{$t('menu.index')}}</span>
                        </MenuItem>
                        <Submenu name="2">
                            <template slot="title">
                                <Icon type="md-settings" />{{$t('menu.systemSetting')}}
                            </template>
                            <MenuItem name="2-1" to="convention">{{$t('menu.conventionSetting')}}</MenuItem>
                            <MenuItem name="2-2" to="loan">{{$t('menu.loanSetting')}}</MenuItem>
                            <MenuItem name="2-3" to="message">{{$t('menu.smsSetting')}}</MenuItem>
                            <MenuItem name="2-4" to="gathering">{{$t('menu.payeeSetting')}}</MenuItem>
                            <MenuItem name="2-5" to="agreement">{{$t('menu.protocolSetting')}}</MenuItem>
                        </Submenu>
                        <MenuItem name="3-1" to="order_text_tip">
                            <Icon type="ios-list-box" />
                            <span>{{$t('menu.orderTextSetting')}}</span>
                        </MenuItem>
                        <!-- <MenuItem name="4-1">
                            <Icon type="md-list-box" />
                            <span>文章列表</span>
                        </MenuItem>-->
                       <MenuItem name="4-1" to="agent">
                            <Icon type="ios-people" />
                            <span>{{$t('menu.agentList')}}</span>
                        </MenuItem>
                       <MenuItem name="4-5" to="kefu">
                            <Icon type="ios-people" />
                            <span>{{$t('agent.phoneKefu')}}</span>
                        </MenuItem>
                        <MenuItem name="8-1" to="invite">
                            <Icon type="ios-people" />
                            <span>{{$t('menu.inviteCode')}}</span>
                        </MenuItem>
                        <MenuItem name="5-1" to="user">
                            <Icon type="ios-people" />
                            <span>{{$t('menu.userList')}}</span>
                        </MenuItem>
                        <MenuItem name="6-1" to="borrow">
                            <Icon type="md-list" />
                            <span>{{$t('menu.borrowList')}}</span>
                        </MenuItem>
                        <MenuItem name="7-1" to="admin">
                            <Icon type="md-person" />
                            <span>{{$t('menu.siteAdminSetting')}}</span>
                        </MenuItem>
                        <MenuItem name="8-1" to="redfile">
                            <Icon type="md-person" />
                            <span>{{$t('redfile')}}</span>
                        </MenuItem>
                    </Menu>
                </Sider>
                <Layout :style="{padding: '24px'}">
                    <!-- <Breadcrumb :style="{margin: '24px 0'}">
                        <BreadcrumbItem>Home</BreadcrumbItem>
                        <BreadcrumbItem>Components</BreadcrumbItem>
                        <BreadcrumbItem>Layout</BreadcrumbItem>
                    </Breadcrumb>-->
                    <Content
                        :style="{padding: '24px', height: content_h, background: '#fff',overflowY: 'scroll'}"
                    >
                        <transition :name="transitionName">
                            <router-view />
                        </transition>
                    </Content>
                </Layout>
            </Layout>
        </Layout>
    </div>
</template>
<script>
export default {
    data() {
        return {
            content_h: 0,
            transitionName: "slide-right",
            active_nav: sessionStorage.getItem("active_nav") || "1-1",
            lang:"zh",
        };
    },
    mounted() {
        this.content_h = document.documentElement.clientHeight - 115 + "px";
    },
    methods: {
        select_nav(name) {
            sessionStorage.setItem("active_nav", name);
        },
        langSwitch(name){
            console.log(name);
            window.localStorage.setItem('localeLanguage',name)
            document.cookie = 'locale='+name;
            //Vue.config.lang = name
            this.$i18n.locale = name
            //this.$i18n.setup(name);
        },
        logout() {
            this.$Modal.confirm({
                title: this.$i18n.t("menu.loginOutTitle"),
                content: "<p>"+this.$i18n.t("menu.loginOutContent")+"</p>",
                onOk: () => {
                    this.$post(this.$path.logout).then(res => {
                        if (res.success) {
                            this.$router.push({ name: "login" });
                        }
                    });
                }
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.layout {
    border: 1px solid #d7dde4;
    background: #f5f7f9;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
}
.ivu-layout-header {
    padding-left: 0;
    height: 60px;
    line-height: 60px;
}
.layout-logo {
    width: 200px;
    height: 60px;
    line-height: 60px;
    float: left;
    padding-left: 15px;
    font-size: 20px;
    font-weight: bold;
    color: #ffffff;
    font-family: cursive;
}
.layout-nav {
    width: 420px;
    margin: 0 auto;
    margin-right: 20px;
}
.ivu-layout-header {
    padding-right: 15px;
}
.logout_box {
    float: right;
    color: #ffffff;
    display: flex;
    flex-direction: row;
    align-items: center;
    .name {
        margin-left: 5px;
    }
    .fh {
        margin: 0 10px;
    }
    .logout {
        font-size: 13px;
        cursor: pointer;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/view.vue